/**
 * Get any CSS variable color from your palette.
 * @param name The CSS variable name without '--', e.g. 'map-route'
 * @param fallback Optional fallback color if not found
 */
export function getColor(name: string, fallback = '#000'): string {
	if (typeof window !== 'undefined') {
		const value = getComputedStyle(document.documentElement).getPropertyValue(`--${name}`).trim();
		return value || fallback;
	}
	return fallback;
}
